import { render, staticRenderFns } from "./CharacterFilter.vue?vue&type=template&id=2c90f84e&scoped=true"
import script from "./CharacterFilter.vue?vue&type=script&lang=js"
export * from "./CharacterFilter.vue?vue&type=script&lang=js"
import style0 from "./CharacterFilter.vue?vue&type=style&index=0&id=2c90f84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c90f84e",
  null
  
)

export default component.exports